import React from 'react'
import { NavigationTabs } from './NavigationTabs'
import { UserMenu } from './UserMenu'

type TabType = 'dispatch' | 'stock' | 'accounting' | 'hr' | 'carStorage' | 'contacts' | 'events' | 'publicServices' | 'giftCards'

interface NavigationProps {
  currentTab: TabType
  onTabChange: (tab: TabType) => void
}

export const Navigation: React.FC<NavigationProps> = ({ currentTab, onTabChange }) => {
  return (
    <nav className="nav-modern">
      <div className="nav-container-modern">
        {/* Section Gauche - Logo + Navigation */}
        <div className="nav-left">
          <div className="nav-brand">
            <div className="nav-logo">
              <img
                src="https://s3.21jumpclick.fr/21depot/logo/enterprise/7.png"
                alt="Logo Benny's"
                width="48"
                height="48"
              />
            </div>
            <div className="nav-title">
              <h1>Benny's</h1>
              <p>Dashboard</p>
            </div>
          </div>

          <NavigationTabs currentTab={currentTab} onTabChange={onTabChange} />
        </div>

        {/* Section Droite - Actions Utilisateur */}
        <div className="nav-right">
          <UserMenu />
        </div>
      </div>
    </nav>
  )
}
